import React from 'react';
import { ErrorMessage } from '../../../../../base/components/Forms/ErrorMessage';
import { FileUpload, FileToUpload } from '../../../../../base/components/Forms/FileUpload';
import { useAppDispatch, useAppSelector } from '../../../../../base/hooks';
import { __t } from '../../../../../base/utils/t';
import { IMAGE_MAX_FILES, IMAGE_MAX_UPLOAD_SIZE, IMAGE_UPLOAD_ALLOWED_FILE_TYPES } from '../../constants';
import { vacancyFormActions } from '../../redux/slices/vacancyFormSlice';

interface Props {
    fullInputMaxWidth?: string;
}

export const ImageUpload = ({ fullInputMaxWidth }: Props) => {
    const dispatch = useAppDispatch();
    const {
        fields: { images, imagesToUpload },
        errors,
        vacancyId,
    } = useAppSelector((state) => state.vacancyForm);

    const setImagesHandler = (files: FileToUpload[]) => {
        dispatch(vacancyFormActions.setField({ id: 'imagesToUpload', value: files, errorGroupName: 'images' }));
    };

    const removeFileToUpload = (id: string) => {
        const filteredList = imagesToUpload.filter((i) => i.id !== id);
        setImagesHandler(filteredList);
    };

    const removeUploadedFile = (id: number) => {
        if (vacancyId) {
            dispatch(vacancyFormActions.deleteImageById(vacancyId, id));
        }
    };

    return (
        <>
            <FileUpload
                filesToUpload={imagesToUpload}
                uploadedFiles={images}
                title={__t('Фото условий труда и проживания')}
                accept={IMAGE_UPLOAD_ALLOWED_FILE_TYPES}
                maxFileSize={IMAGE_MAX_UPLOAD_SIZE}
                maxFiles={IMAGE_MAX_FILES}
                fullInputMaxWidth={fullInputMaxWidth}
                setFiles={setImagesHandler}
                removeFileToUpload={removeFileToUpload}
                removeUploadedFile={removeUploadedFile}
            />
            <ErrorMessage errors={errors?.images} />
        </>
    );
};
